<div *ngIf="isLoading">Loading Delivery Method List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="deliveryMethod" [(ngModel)]="model.deliveryMethod" [required]="required">
  <option *ngFor="let singleDeliveryMethod of deliveryMethods" [ngValue]="singleDeliveryMethod">{{ singleDeliveryMethod.name }}</option>
</select>
